import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { themeGet } from "sprout-ui-theme";
import { Box, Flex } from "sprout-ui-primitives";
import styled from "styled-components";
import clsx from "clsx";
const SwitchWrapper = styled(Flex)`
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  cursor: pointer;

  &.disabled {
    cursor: not-allowed;
  }
`;
const SwitchInput = styled("input")`
  width: 62px;
  height: 48px;

  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
  margin: 0;
  padding: 0;
  cursor: inherit;
  z-index: 1;
`;
const SwitchTrack = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  transition: background 0.15s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);

  .checked & {
    background: ${themeGet("colors.blue.500")};
    opacity: 0.6;
  }
`;
const SwitchThumbWrapper = styled(Flex)`
  position: relative;
  transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);

  .checked & {
    transform: translate3d(14px, 0, 0);
  }
`;
const SwitchThumb = styled(Box)`
  box-shadow: 0px 2px 1px -1px ${themeGet("colors.black.24")},
    0px 1px 1px 0px ${themeGet("colors.black.14")},
    0px 1px 3px 0px ${themeGet("colors.black.12")};
  transition: background 0.15s cubic-bezier(0.4, 0, 0.2, 1);

  .checked & {
    background: ${themeGet("colors.blue.500")};
  }
`;
const Switch = (props)=>{
    const { checked , onChange , name , disabled , id  } = props;
    const className = clsx({
        checked,
        disabled
    });
    return /*#__PURE__*/ _jsxs(SwitchWrapper, {
        width: "62px",
        height: "48px",
        className: className,
        children: [
            /*#__PURE__*/ _jsx(SwitchInput, {
                id: id,
                name: name,
                disabled: disabled,
                type: "checkbox",
                checked: checked,
                onChange: onChange
            }),
            /*#__PURE__*/ _jsx(SwitchTrack, {
                width: "34px",
                height: "14px",
                bg: disabled ? "black.14" : "black.38",
                borderRadius: "12px"
            }),
            /*#__PURE__*/ _jsx(SwitchThumbWrapper, {
                width: "48px",
                height: "48px",
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ _jsx(SwitchThumb, {
                    bg: disabled ? "grey.200" : "white.100",
                    borderRadius: "50%",
                    width: "20px",
                    height: "20px"
                })
            })
        ]
    });
};
export default Switch;
